import React from "react";
import { ArrowRight, Zap, TrendingUp, Shield, Rocket } from "lucide-react";

const comparisons = [
  {
    id: 1,
    title: "Pinecone vs Qdrant",
    description: "Managed convenience vs open-source flexibility. Compare pricing, performance, and migration complexity.",
    icon: Zap,
    stats: "Most Popular",
    link: "/comparisons/pinecone-vs-qdrant"
  },
  {
    id: 2,
    title: "Qdrant vs Weaviate",
    description: "Two powerful open-source solutions. Which filtering capabilities and deployment options suit you best?",
    icon: TrendingUp,
    stats: "Developer Favorite",
    link: "/comparisons/qdrant-vs-weaviate"
  },
  {
    id: 3,
    title: "Chroma vs Pinecone",
    description: "Embedded simplicity vs cloud-native scale. Compare ease of use, cost efficiency, and production readiness.",
    icon: Rocket,
    stats: "Startup Choice",
    link: "/comparisons/chroma-vs-pinecone"
  },
  {
    id: 4,
    title: "Weaviate vs Pinecone",
    description: "GraphQL flexibility vs API simplicity. Deep dive into features, pricing models, and hybrid search capabilities.",
    icon: Shield,
    stats: "Enterprise Grade",
    link: "/comparisons/weaviate-vs-pinecone"
  },
  {
    id: 5,
    title: "Qdrant vs Milvus",
    description: "Filtering-first design vs massive-scale vector search. Compare performance, scalability, and operational complexity.",
    icon: TrendingUp,
    stats: "Scale Focused",
    link: "/comparisons/qdrant-vs-milvus"
  },
  {
    id: 6,
    title: "Weaviate vs Milvus",
    description: "Semantic-native search vs distributed vector scale. Explore hybrid search, deployment models, and ecosystem maturity.",
    icon: Shield,
    stats: "AI Powerhouses",
    link: "/comparisons/weaviate-vs-milvus"
  },
  {
    id: 7,
    title: "Chroma vs Milvus",
    description: "Local-first prototyping vs production-scale vectors. Compare developer experience, scalability, and use cases.",
    icon: Rocket,
    stats: "Prototype → Production",
    link: "/comparisons/chroma-vs-milvus"
  }
];

const ComparisonCard = ({ comparison }) => {
  const Icon = comparison.icon;

  return (
    <a
      href={comparison.link}
      className="group block bg-bg-soft border border-border rounded-xl p-6 transition-all duration-300 hover:scale-105 hover:border-border-strong hover:shadow-md cursor-pointer"
    >
      {/* Badge */}
      <div className="flex items-start justify-between mb-4">
        <span className="text-xs font-semibold px-3 py-1 rounded-full bg-primary text-white">
          {comparison.stats}
        </span>
      </div>

      {/* Title */}
      <h3 className="text-xl font-bold mb-3 text-text-primary">
        {comparison.title}
      </h3>

      {/* Description */}
      <p className="text-sm mb-4 leading-relaxed text-text-secondary">
        {comparison.description}
      </p>

      {/* CTA */}
      <div className="flex items-center text-sm font-semibold gap-2 group-hover:gap-3 transition-all text-text-primary">
        View Detailed Comparison
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </div>
    </a>
  );
};

export default function ComparisonHub() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mt-3 mb-4 text-text-primary">
            Compare Vector Databases
          </h2>
          <p className="text-lg max-w-2xl mx-auto text-text-secondary">
            Not sure which vector database is right for you? We've analysed the top platforms
            to help you make the best choice for your AI applications.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {comparisons.map(comparison => (
            <ComparisonCard key={comparison.id} comparison={comparison} />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <p className="text-sm text-text-muted">
            Can't decide? We can help you migrate between any of these platforms seamlessly.
          </p>
        </div>

      </div>
    </section>
  );
}